import './servicedetailcomponents.css';
import '../../../App.css';
import Footer from '../../../components/Footer/Footer';
// import Header from '../../../components/header/Header';
import Menu from '../../../components/menu/Menu';
import MobileMenu from '../../../components/mobile_tabmennu/MobileMenu';
import { useLocation } from 'react-router-dom';
const ServiceDetailsComponent=()=>{

    const location = useLocation();
    const dataReceived = location.state;
    console.log(dataReceived?.servicepointlist)

    return(
        <div className='service-detail-container'>
                {/* <div className="app-pc-menu top-bar">
                <Header/>
                </div> */}
                <div className='app-pc-menu'>
                <Menu page={'SERVICE'}/>
                </div>
                <div className='app-mobile-menu'>
                <MobileMenu/>
            </div>


            <div className='service-main-detail-container'>
                <div className='service-main-detail-first-ctn'>
                    <h2 className='service-main-detail-first-header1'>
                     {dataReceived.serviceName}
                    </h2>
                     <h4 className='service-main-detail-first-header service-main-detail-first-header2'>Unlock the Power of {dataReceived.serviceName} for Your Business Success</h4>
                    <p style={{fontSize:"17px"}}>{dataReceived?.servicecontent}</p>
                </div>
                <div className='service-main-detail-sec-ctn'>
                    <img src={dataReceived.servicecoverimagelink}/>
                </div>
            </div>



            <div style={{backgroundImage:`url(${dataReceived.servicehighlightcoverimage})`}} className='service-highlight-container' >
                <h1 style={{color:"#fff", fontSize:"2.8rem", padding:"0.5rem 0px"}}>{dataReceived.serviceName}</h1>
                <h5 style={{color:"#fff", fontSize:"1.2rem", padding:"0.5rem 0px", lineHeight:"2rem"}}>Improve your business processes with the help of our<br/> custom platform development.</h5>
            </div>

            <div className='service-decription-continainer'>

                    {dataReceived?.servicepointlist.map((list)=>{
                        return(
                            <div style={{padding:"1rem"}}>
                            <h4 className='service-main-detail-first-header'>{list[0]}</h4>

                            <div className='service-main-detail-text-container'>

                                <div className='service-main-detail-icon' style={{backgroundImage:`url(${dataReceived.listicon})`}}>
                                   
                                </div>

                                <div style={{padding:"0.5rem", fontSize:"17px"}} >{list[1]}</div>
                            </div>
                            <div className='service-main-detail-text-container'>

                                <div className='service-main-detail-icon' style={{backgroundImage:`url(${dataReceived.listicon})`}}>
                                  
                                </div>

                                <div style={{padding:"0.5rem", fontSize:"17px"}} >{list[2]}</div>
                                </div>

                            {/* <li style={{padding:"0.5rem", fontSize:"17px"}}>{list[1]}</li> */}
                            {/* <li style={{padding:"0.5rem", fontSize:"17px"}}>{list[2]}</li> */}
                            </div>
                        )
                    })}
                

            </div>

            <Footer/>
        </div>
    )
}

export default ServiceDetailsComponent;